import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    contactQueryList: {},
    notification: {},
};

const ContactQuerySlice = createSlice({
    name: 'contact',
    initialState,
    reducers: {
        setContactQueryList(state, action) {
            state.contactQueryList = action.payload;
        },
        setToast(state, action) {
            state.notification = action.payload;
        },

    },
});



export const ContactListApi = (tokendata, page, limit, search) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/contactQueryList?page=${page}&limit=${limit}&search=${search}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setContactQueryList(res?.data?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))

        })

}




export const { setContactQueryList, setToast } = ContactQuerySlice.actions;
const ContactQueryReducer = ContactQuerySlice.reducer;

export default ContactQueryReducer;
